import { ReactElement } from 'react';
import { UIText } from '../ui-text';
import styles from './ui-progress-stepper.module.scss';

type UIProgressStepperProps = {
    steps: string[];
    activeStep?: number;
    onStepClick?: (step: number) => void;
};

export function UIProgressStepper(props: UIProgressStepperProps): ReactElement {
    const { steps, activeStep = 0, onStepClick } = props;
    return (
        <div className={styles.container}>
            {/* Circle/Lines */}
            <div className={styles.circleLineContainer}>
                {steps.map((_step, index) => {
                    const isActive = index <= activeStep;
                    const isNextActive = activeStep > index;
                    return (
                        <div key={index} className={styles.itemContainer}>
                            <div
                                className={`${styles.line} ${
                                    isActive ? styles.highlightedLine : ''
                                } ${index === 0 ? styles.invisibleLine : ''}`}
                            />
                            <button
                                key={index}
                                className={`${styles.circle} ${
                                    index <= activeStep
                                        ? styles.circleSelected
                                        : ''
                                }`}
                                disabled={index > activeStep}
                                onClick={() => {
                                    onStepClick?.(index);
                                }}
                            />
                            <div
                                className={`${styles.line} ${
                                    isNextActive ? styles.highlightedLine : ''
                                } ${
                                    index === steps.length - 1
                                        ? styles.invisibleLine
                                        : ''
                                }`}
                            />
                        </div>
                    );
                })}
            </div>

            {/* Step text */}
            <div className={styles.stepTextContainer}>
                {steps.map((step, index) => (
                    <div key={index} className={styles.itemContainer}>
                        <UIText key={index}>{step}</UIText>
                    </div>
                ))}
            </div>
        </div>
    );
}
